module.exports = __webpack_public_path__ + "img/reportLost.7d24c802.png";